/**
 * `timeline` — measured: the four plain rows, then the **six comparisons twice**, once for
 * the end date and once for the start date, in that order. monday carries the half in
 * `ItemsQueryRule.compare_attribute`, and so do we (`"end"` / `"start"`).
 */
import { IS_EMPTY, IS_NOT_EMPTY, condition, } from '../filter-conditions.js';
/** The six comparisons for one end of the range. */
function half(edge) {
    const verb = edge === 'end' ? 'ends' : 'starts';
    return [
        condition(`${verb} between`, 'between', 'dateRange', { compareAttribute: edge }),
        condition(`${verb} on`, 'any_of', 'date', { compareAttribute: edge }),
        condition(`${verb} after`, 'greater_than', 'date', { compareAttribute: edge }),
        condition(`${verb} on or after`, 'greater_than_or_equals', 'date', { compareAttribute: edge }),
        condition(`${verb} before`, 'lower_than', 'date', { compareAttribute: edge }),
        condition(`${verb} on or before`, 'lower_than_or_equal', 'date', { compareAttribute: edge }),
    ];
}
export const timelineFilterConditions = [
    condition('is', 'any_of', 'dateRange', { id: 'any_of' }),
    condition('is not', 'not_any_of', 'dateRange', { id: 'not_any_of' }),
    IS_EMPTY,
    IS_NOT_EMPTY,
    ...half('end'),
    ...half('start'),
];
//# sourceMappingURL=filters.js.map